<template>
    <div>
        <vue-topprogress ref="loadingProgress"></vue-topprogress>

        <form class="animated fade-in" v-if="!loading" @submit.prevent="onSubmit">

            <c-card>
                <c-card-body>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Customer"
                        v-model="estimate.customer_name"
                        :isValid="!$v.estimate.customer_name.$invalid"
                        invalidFeedback="Required"
                    ></c-input>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Plan #"
                        v-model="estimate.plan_number"
                        :isValid="!$v.estimate.plan_number.$invalid"
                        invalidFeedback="Required"
                    ></c-input>
                    <!-- <b-form-group label-cols="2" label="Attention" class="mb-0" :state="!$v.estimate.attention.$invalid" invalid-feedback="Required">
                        <b-form-tags v-model="estimate.attention" separator=" ,;" placeholder="Enter name(s) separated by space, comma or semicolon" :state="!$v.estimate.attention.$invalid"></b-form-tags>
                    </b-form-group> -->
                    <b-form-group label="Transport Type" label-cols-md="2">
                      <b-form-radio-group
                        v-model="estimate.transport" 
                        :options="['Delivery','Pickup'].map(i=>{return{value:i,text:i}})"
                        buttons
                      ></b-form-radio-group>
                    </b-form-group>
                </c-card-body>
            </c-card>

            <c-card>
                <c-card-header><h6 class="m-0 p-0 font-weight-bold">Contact</h6></c-card-header>
                <c-card-body>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="First Name"
                        v-model="contact.first_name"
                        :isValid="!$v.contact.first_name.$invalid"
                        invalidFeedback="Required"
                    ></c-input>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Last Name"
                        v-model="contact.last_name"
                        :isValid="!$v.contact.last_name.$invalid"
                        invalidFeedback="Required"
                    ></c-input>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Phone"
                        v-model="contact.phone"
                        :isValid="!$v.contact.phone.$invalid"
                        invalidFeedback="Required"
                    ></c-input>
                    <!-- <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Email"
                        v-model="contact.email"
                        :isValid="!$v.contact.email.$invalid"
                        invalidFeedback="Required"
                        class="mb-0"
                    ></c-input> -->
                </c-card-body>
            </c-card>

            <c-card head v-if="estimate.transport === 'Delivery'">
                <c-card-header><h6 class="m-0 p-0 font-weight-bold">Shipping Address</h6></c-card-header>
                <c-card-body>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Street Address"
                        v-model="shipping.street_address"
                        :isValid="!$v.shipping.street_address.$invalid"
                        invalidFeedback="Required"
                    ></c-input>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="City"
                        v-model="shipping.city"
                        :isValid="!$v.shipping.city.$invalid"
                        invalidFeedback="Required"
                    ></c-input>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Province/State"
                        v-model="shipping.region"
                        :isValid="!$v.shipping.region.$invalid"
                        invalidFeedback="Required"
                    ></c-input>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Country"
                        v-model="shipping.country"
                        :isValid="!$v.shipping.country.$invalid"
                        invalidFeedback="Required"
                    ></c-input>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Postal/Zip Code"
                        v-model="shipping.postal"
                        :isValid="!$v.shipping.postal.$invalid"
                        invalidFeedback="Required"
                        class="mb-0"
                    ></c-input>
                </c-card-body>
            </c-card>

            <!-- <c-card>
                <c-card-body>
                    <b-form-group 
                        :state="!$v.sections.$invalid"
                        invalid-feedback="At least one section is required"
                        class="mb-0"
                    >
                        <b-form-tags 
                            :state="!$v.sections.$invalid"
                            v-model="sections" 
                            separator=" ,;" 
                            remove-on-delete
                            placeholder="Enter section(s) separated by space, comma or semicolon"
                        ></b-form-tags>
                    </b-form-group>
                </c-card-body>
            </c-card> -->

            <c-card v-if="customer && products && product_types && items">
                <c-card-body>
                    <b-tabs>
                        <br />
                        <b-tab v-for="section in sections" 
                            :title="section + ' (' + items.filter((i)=>i.section&&i.section===section).length + ')'" 
                            :key="section">
                            <estimate-customer-item-form
                                :section="section"
                                :customer="customer"
                                :product_types="product_types"
                                :products="products"
                                :existing_items="items.filter((i)=>i.section&&i.section===section)"
                                @update="updateItems"
                            ></estimate-customer-item-form>
                            <b-form-group :label="section + ' Note'" label-cols-sm="2">
                                <b-textarea 
                                    :value="notes.find((i)=>i.section&&i.section===section) ? notes.find((i)=>i.section&&i.section===section).note : null"
                                    @update="updateNote(section, $event)"
                                ></b-textarea>
                            </b-form-group>
                        </b-tab>
                    </b-tabs>
                </c-card-body>
            </c-card>

            <c-card>
                <c-card-body>
                    <b-form-group :label="'Note'" label-cols-sm="2">
                        <b-textarea 
                            :value="notes.find(i=>!i.section) ? notes.find(i=>!i.section).note : null"
                            @update="updateNote(null, $event)"
                        ></b-textarea>
                    </b-form-group>
                    <!-- <c-textarea
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="Note"
                        v-model="note.note"
                        :isValid="!$v.note.note.$invalid"
                        invalidFeedback=""
                    ></c-textarea> -->
                </c-card-body>
            </c-card>

            <c-card>
              <c-card-header><h6 class="m-0 p-0 font-weight-bold">Totals</h6></c-card-header>
              <c-card-body>
                <b-table :items="totals" :fields="['name','quantity','price','subtotal','tax','total']" :tbody-tr-class="totalRowClass" small striped>
                  <template #cell(price)="data"><td>{{ data.value ? '$'+data.value.toFixed(2) : '' }}</td></template>
                  <template #cell(subtotal)="data"><td>{{ data.value ? '$'+data.value.toFixed(2) : '' }}</td></template>
                  <template #cell(tax)="data"><td>{{ data.value ? '$'+data.value.toFixed(2) : '' }}</td></template>
                  <template #cell(total)="data"><td>{{ data.value ? '$'+data.value.toFixed(2) : '' }}</td></template>
                </b-table>
              </c-card-body>
            </c-card>

            <b-progress v-if="step_number" :max="step_max" height="1.8rem" class="mb-4">
                <b-progress-bar :value="step_number" :variant="step_variant">
                    <b>{{step_label}}</b>
                </b-progress-bar>
            </b-progress>

            <div class="clearfix mb-5">
                <div class="d-inline-block  float-right">
                    <b-overlay :show="saving" spinner-small>
                        <c-button class="btn-sf btn-square" type="submit">
                            <i class="fal fa-save"></i> Save
                        </c-button>
                    </b-overlay>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import Product from "@/models/Product";
  import ProductType from "@/models/ProductType";
  import Customer from "@/models/Customer";
  import Contact from "@/models/Contact";
  import Location from "@/models/Location";
  import InsulationCut from '@/models/InsulationCut';
  import CustomerEstimate from '@/models/CustomerEstimate';
  import CustomerEstimateItem from '@/models/CustomerEstimateItem';
  import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
  import EstimateCustomerItemForm from "./EstimateCustomerItemForm";
  import {GREEDY_FETCH_ENTITY} from "@/store/action-types";
  import { validationMixin } from 'vuelidate';
  import { required, minLength } from 'vuelidate/lib/validators';
import Note from '../../../models/Note';
import OrderItem from '../../../models/OrderItem';

  export default {
      name: 'EstimateCustomerForm',
      components: {EstimateCustomerItemForm},
      mixins: [ToastNotifications, validationMixin],
      props: ['customer_estimate'],
      data () {
        return {

          loading: true,
          saving: false,
          step_number: null,
          step_label: null,
          step_variant: 'info',
          step_max: 4,

          estimate: {
            customer_name: null,
            plan_number: null,
            attention: null,
            transport: 'Delivery'
          },

          contact: {
            first_name: null,
            last_name: null,
            phone: null,
            email: null
          },

          shipping: {
            name: 'Shipping Address',
            street_address: null,
            city: null,
            region: null,
            country: null,
            postal: null
          },

          notes: [],

          customer: null,
          last_customer_estimate: null,
          product_types: [],
          products: [],

          fields: [
          	{key: 'actions', label: 'Actions'},
          	{key: 'section', label: 'Section'},
            {key: 'previews', label: 'Preview(s)'},
            {key: 'products', label: 'Product(s)'},
            {key: 'quantity', label: 'Qty'},
            {key: 'price', label: 'Price'},
            {key: 'tax_percent', label: 'Tax(%)', },
            {key: 'specs', label: 'Spec(s)'},
          ],

          items: [],
          totals: [],
          sections: [
            'Frost Wall',
            'Foundation Wall',
            'Garage Foundation Wall',
            'Grade Beam',
            'Main Floor Wall',
            'Second Floor Wall',
            'Third Floor Wall',
            'Garage Wall',
            'Party Wall',
            'Gable Wall',
            'Retaining Wall',
            'Shipping'
          ],
        }
      },
      validations: {
        estimate: {
          customer_name: {required},
          plan_number: {required},
          attention: {},
          transport: {required}
        },
        contact: {
          first_name: {required},
          last_name: {},
          phone: {required},
          email: {}
        },
        shipping: {
          name: {required},
          street_address: {required},
          city: {required},
          region: {required},
          country: {required},
          postal: {required}
        },
        items: {required,minLength},
        notes: {},
        sections: {required,minLength},
      },
      methods: {

        updateTotals() {
            let totals = [];
            let t_q = null;
            let t_st = null;
            let t_ta = null;
            let t_to = null;
            this.items.forEach((item => {
              let name = OrderItem.parseFilteredName(Product.find(+(item.product_id)), 
                (item.type && item.type.name === 'Insulation' ? item.insulation_cut : null), item.description);
              if(item.section === 'Shipping') {
                name = 'Shipping to ' + name;
              }
              let index = totals.findIndex(i=>+(i.product_id)===+(item.product_id));
              let quantity = Math.abs(item.quantity);
              let price = Math.abs(item.price);
              let subtotal = quantity*price;
              let tax = subtotal*(Math.abs(item.tax_percent)/100);
              let total = subtotal+tax;
              if(index !== -1) {
                let updated = totals[index];
                updated.quantity = updated.quantity + quantity;
                updated.subtotal = updated.subtotal + subtotal;
                updated.tax = updated.tax + tax;
                updated.total = updated.total + total;
                totals.splice(index, 1, updated);
              } else {
                totals.push({
                  product_id: item.product_id, name, quantity, price: null, subtotal, tax, total
                });
              }
              t_q = (t_q?t_q:0) + quantity;
              t_st = (t_st?t_st:0) + subtotal;
              t_ta = (t_ta?t_ta:0) + tax;
              t_to = (t_to?t_to:0) + total;
            }));
            totals.forEach(i=>{
              i.price = i.subtotal / i.quantity;
            });
            totals.push({product_id: null, name: 'Total', quantity: t_q, price: null, subtotal: t_st, tax: t_ta, total: t_to});
            this.totals = totals;
          },

          totalRowClass(item) {
            return {'font-weight-bold': item.name === 'Total' ? true : false};
          },

        updateItems(items, section) {
            let idpool = items.map(i=>i.$uid);
            items.forEach(i => {
                let index = this.items.findIndex(j=>i.$uid===j.$uid);
                if(index !== -1) {
                    this.items.splice(index, 1, i);
                } else {
                    this.items.push(i);
                }
            });
            let iddelete = this.items.filter(i=>i.section===section&&!idpool.includes(i.$uid)).map(i=>i.$uid);
            iddelete.forEach(uid => {
                let index = this.items.findIndex(i=>uid===i.$uid);
                if(index !== -1) {
                    this.items.splice(index, 1);
                }
            });
            this.items.sort((a,b)=>(a.section<=b.section&&a.section!=='Shipping'?-1:1));
            this.updateTotals();
        },

        updateNote(section, note) {
            if(this.notes.find(i=>(section && i.section && i.section === section) || (!section && !i.section))) {
                this.notes.find(i=>(section && i.section && i.section === section) || (!section && !i.section)).note = note;
            } else {
                this.notes.push({section: (section?section:null), note});
            }
        },

        onSubmit() {

          this.saving = true;
          this.step_number = null;
          this.step_label = null;
          this.step_variant = 'info';

          if(this.$v && this.$v.estimate && this.$v.estimate.$invalid) {
            this.quickWarningToast('Form Invalid', 'Estimate details are not complete.');
            this.saving = false;
            return false;
          }

          if(this.$v && this.$v.contact && this.$v.contact.$invalid) {
            this.quickWarningToast('Form Invalid', 'Contact details are not complete.');
            this.saving = false;
            return false;
          }

          if(this.estimate.transport === 'Delivery') {
            if(this.$v && this.$v.shipping && this.$v.shipping.$invalid) {
              this.quickWarningToast('Form Invalid', 'Address details are not complete.');
              this.saving = false;
              return false;
            }
            let shipping_item = this.items.filter(i=>i.section==='Shipping');
            if(!shipping_item || !shipping_item.length) {
              this.quickWarningToast('Form Invalid', 'No shipping was specified. Please click on the shipping tab to manage shipping costs.');
              this.saving = false;
              return false;
            }
          }

          if(this.$v && this.$v.items && this.$v.items.$invalid) {
            this.quickWarningToast('Form Invalid', 'No items have been added to this estimate.');
            this.saving = false;
            return false;
          }

          try {
            this.items.forEach(i => {
                if(!i.product_id && !i.description) {
                    throw 'Item product was not specified.';
                }
                if(!i.section) {
                    throw 'Item section was not specified.';
                }
                if(!i.quantity) {
                    throw 'Item quantity was not specified.';
                }
                if(!i.price) {
                    throw 'Item price was not specified.';
                }
                if(!i.tax_percent) {
                    throw 'Item tax percent was not specified.';
                }
            });
          } catch(item_error) {
            this.quickWarningToast('Form Invalid', item_error);
            this.saving = false;
            return false;
          }
          
          let id = this.customer_estimate ? this.customer_estimate.id : null;
          let contact_id = this.customer_estimate ? this.customer_estimate.contact_id : null;
          let shipping_id = this.customer_estimate ? this.customer_estimate.shipping_id : null;
          //let note_id = this.customer_estimate ? this.customer_estimate.note_id : null;

          let setStep = (step_number, step_label) => {
            this.step_number = step_number;
            this.step_label = step_label;
          }

          let handleError = (context, err) => {
            this.step_label = 'The '+context+' could not be saved. Please try again later.';
            this.quickWarningToast('Something Went Wrong', this.step_label);
            this.step_variant = 'danger';
            this.saving = false;
            return false;
          }

          let getItemRequests = (new_estimate_id) => {
            let requests = [];
            this.items.forEach(i => {
              let cut_request = null;
              if(i.type && i.type.name === 'Insulation') {
                  if(i.insulation_cut && i.insulation_cut.thickness) {
                      let cut_id = i.insulation_cut.id;
                      let cut_payload = {...i.insulation_cut};
                      delete cut_payload.id;
                      cut_request = (cut_id ? InsulationCut.api().update(cut_id, cut_payload) : InsulationCut.api().create(cut_payload));
                  }
              }
              let payload = {
                  customer_estimate_id: new_estimate_id, 
                  product_id: (i.product_id ? i.product_id : null), 
                  insulation_cut_id: null, 
                  section: (i.section ? i.section : null), 
                  quantity: (i.quantity ? i.quantity : null), 
                  price: (i.price ? i.price : null), 
                  tax_percent: (i.tax_percent ? i.tax_percent : null),
                  description: (i.description ? i.description : null)
              };
              if(cut_request) {
                requests.push(cut_request.then((cut_result) => {
                    let cut = cut_result.entities[InsulationCut.entity];
                    cut = cut ? cut.find(i => true) : null;
                    payload.insulation_cut_id = cut ? cut.id : null;
                    return (i.id ? CustomerEstimateItem.api().update(i.id, payload) : CustomerEstimateItem.api().create(payload));
                }));
              } else {
                requests.push((i.id ? CustomerEstimateItem.api().update(i.id, payload) : CustomerEstimateItem.api().create(payload)));
              }
            });
            return requests;
          }

          setStep(1, 'Saving Contact');
          let results = (contact_id ? Contact.api().update(contact_id, this.contact) : Contact.api().create(this.contact)).then((c_result) => {
            let contact = c_result.entities[Contact.entity];
            contact = contact ? contact.find(i => true) : null;
            contact_id = contact ? contact.id : null;
            
            setStep(2, 'Saving Location');
            return (
              (this.estimate.transport === 'Delivery' ? (shipping_id ? Location.api().update(shipping_id, this.shipping) : Location.api().create(this.shipping)) : new Promise((resolve)=>{return resolve(null)}))
              ).then((l_result) => {
              if(l_result) {
                let shipping = l_result.entities[Location.entity];
                shipping = shipping ? shipping.find(i => true) : null;
                shipping_id = shipping ? shipping.id : null;
              }

            //   setStep(3, 'Saving Note');
            //   let tmp_request = this.note.note ? (note_id ? Note.api().update(note_id, this.note) : Note.api().create(this.note)) : new Promise(resolve => {return resolve()});
            //   return tmp_request.then((n_result) => {
            //     let note = n_result ? n_result.entities[Note.entity] : null;
            //     note = note ? note.find(i => true) : null;
            //     note_id = note ? note.id : null;
              
                let tmp = {...this.estimate};
                tmp.customer_id = this.customer.id;
                tmp.contact_id = contact_id;
                tmp.shipping_id = shipping_id;
                tmp.notes = this.notes ? JSON.stringify(this.notes) : null;
                //tmp.note_id = note_id;
                tmp.attention = tmp.attention ? JSON.stringify(tmp.attention) : null;

                setStep(3, 'Saving Estimate');
                return (id ? CustomerEstimate.api().update(id, tmp) : CustomerEstimate.api().create(tmp)).then((e_result) => {
                    let estimate = e_result.entities[CustomerEstimate.entity];
                    estimate = estimate ? estimate.find(i => true) : null;
                    let estimate_id = estimate ? estimate.id : null;

                    setStep(4, 'Saving Estimate Items');
                    return Promise.all(getItemRequests(estimate_id)).then(() => {
                        setStep(6, 'Saved Estimate');
                        this.quickSuccessToast('Estimate Created', 'You will be redirected to your estimates.');
                        this.saving = false;
                        this.$router.push('/estimates/generated');
                        return true;
                    }, (err) => {
                        return handleError('estimate items');
                    });

                }, (err) => {
                    return handleError('estimate');
                });

            //   }, (err) => {
            //     return handleError('note');
            //   });

            }, (err) => {
              return handleError('shipping');
            });

          }, (err) => {
            return handleError('contact');
          });

          return results;

        },
        fetch() {
            return Promise.all([
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: ProductType, refresh: true}),
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: Product, refresh: true}),
              Customer.api().retrieve(this.$store.getters.getAuthCustomerID),
              CustomerEstimate.api().fetch({customer_id: this.$store.getters.getAuthCustomerID, last: true}),
            ]);
        },
        populate() {
            return new Promise((resolve) => {
              let customer_id = this.$store.getters.getAuthCustomerID;
              this.product_types = ProductType.query().with([
                'product_categories.products',
                'product_classifications.products'
              ], (query) => {
               query.orderBy('number');
              }).get();
              this.customer = Customer.find(customer_id);
              this.last_customer_estimate = CustomerEstimate.query().with('customer')
                .orderBy('index','DESC').where('customer_id', customer_id).first();
              this.fillWithCustomerEstimate();
              this.updateTotals();
              resolve();
            });
        },
        fillWithCustomerEstimate() {
            if(this.customer_estimate) {
                this.estimate.customer_name = this.customer_estimate.customer_name;
                this.estimate.plan_number = this.customer_estimate.plan_number;
                this.estimate.attention = JSON.parse(this.customer_estimate.attention);
                this.estimate.transport = this.customer_estimate.transport;
                let items = this.customer_estimate.customer_estimate_items;
                items = items ? items : [];
                items.forEach((item) => {
                    /*if(item.section && !this.sections.includes(item.section)) {
                        this.sections.push(item.section);
                    }*/
                    let item_product = Product.query().where('id', item.product_id).with(['product_category.products', 'product_type.product_classifications.products', 'product_type.product_categories.products']).first();
                    if(item_product) {
                      this.newRow(item_product.product_type, item_product.product_category, item_product, item);
                    } else {
                      this.newRow(ProductType.query().where('name','Other').first(), null, null, item);
                    }
                });
                if(this.customer_estimate.contact) {
                    this.contact.first_name = this.customer_estimate.contact.first_name;
                    this.contact.last_name = this.customer_estimate.contact.last_name;
                    this.contact.phone = this.customer_estimate.contact.phone;
                    this.contact.email = this.customer_estimate.contact.email;
                }
                if(this.customer_estimate.shipping) {
                    this.shipping.street_address = this.customer_estimate.shipping.street_address;
                    this.shipping.city = this.customer_estimate.shipping.city;
                    this.shipping.region = this.customer_estimate.shipping.region;
                    this.shipping.country = this.customer_estimate.shipping.country;
                    this.shipping.postal = this.customer_estimate.shipping.postal;
                }
                let notes = JSON.parse(this.customer_estimate.notes);
                if(notes && notes.length) {
                    notes.forEach(i => {
                        this.notes.push(i);
                    });
                }
                // if(this.customer_estimate.note) {
                //     this.note.note = this.customer_estimate.note.note;
                // }
            }
        },
        newRow(type, category, product, item) {
          this.items.push({
            $uid: this.uniqid(),
            id: item && item.id ? item.id : null,
            type: type,
            category: category,
            product_id: product ? product.id : null,
            insulation_cut: {
              id: (item && item.insulation_cut && item.insulation_cut.id ? item.insulation_cut.id : null),
              thickness: (item && item.insulation_cut && item.insulation_cut.thickness ? item.insulation_cut.thickness : null),
              thickness_unit: (item && item.insulation_cut && item.insulation_cut.thickness_unit ? item.insulation_cut.thickness_unit : (type && type.name === 'Insulation' ? 'in' : null)),
              width: (item && item.insulation_cut && item.insulation_cut.width ? item.insulation_cut.width : null),
              width_unit: (item && item.insulation_cut && item.insulation_cut.width_unit ? item.insulation_cut.width_unit : (type && type.name === 'Insulation' ? 'ft' : null)),
              length: (item && item.insulation_cut && item.insulation_cut.length ? item.insulation_cut.length : null),
              length_unit: (item && item.insulation_cut && item.insulation_cut.length_unit ? item.insulation_cut.length_unit : (type && type.name === 'Insulation' ? 'ft' : null)),
            },
            section: item && item.section ? item.section : null,
            quantity: item && item.quantity ? item.quantity : null,
            price: item && item.price ? item.price : null,
            tax_percent: item && item.tax_percent ? item.tax_percent : 5,
            description: item && item.description ? item.description : null
          });
        },
        uniqid(a = "", b = false) {
            const c = Date.now()/1000;
            let d = c.toString(16).split(".").join("");
            while(d.length < 14) d += "0";
            let e = "";
            if(b){
                e = ".";
                e += Math.round(Math.random()*100000000);
            }
            return a + d + e;
        },
        test() {
          this.estimate.customer_name = this.$faker().name.firstName() + ' ' + this.$faker().name.lastName();
          this.estimate.plan_number = this.$faker().random.uuid();
          this.estimate.attention = [this.$faker().name.firstName()];
          this.contact.first_name = this.$faker().name.firstName();
          this.contact.last_name = this.$faker().name.lastName();
          this.contact.phone = this.$faker().phone.phoneNumberFormat();
          this.contact.email = this.$faker().internet.email();
          this.shipping.street_address = this.$faker().address.streetAddress();
          this.shipping.city = this.$faker().address.city();
          this.shipping.region = this.$faker().address.state();
          this.shipping.country = this.$faker().address.country();
          this.shipping.postal = this.$faker().address.zipCode();
        }
      },
      mounted() {
        this.$refs.loadingProgress.start();
        this.fetch().then(() => {
          this.populate().then(() => {
            this.loading = false;
            this.$refs.loadingProgress.done();
          });
        });
      },
      created() {
        this.loading = true;
      }
	}
</script>
<style>
    .custom-select {
        font-size: 0.85rem;
    }
    .prepend-sm .input-group-text, .append-sm .input-group-text {
        font-size: 0.85rem;
    }
</style>
